import { atom, useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Dialog, Stack, Typography } from '@mui/material';

import type { ReactNode } from 'react';

interface ProfileSectionCardProp {
  title: string;
  value: string;
  children?: ReactNode;
}

export const settingPopOpenAtom = atom({ open: '' });

export default function ProfileSectionCard({ title, value, children }: ProfileSectionCardProp) {
  const { t, i18n } = useTranslation();
  const [openTarget, setOpenTarget] = useAtom(settingPopOpenAtom);

  return (
    <Stack>
      <Typography variant="h6" color="gray" fontWeight={'bold'}>
        {title}
      </Typography>
      <Typography color="gray">{value}</Typography>
      {children && (
        <>
          <Typography color="primary" sx={{ cursor: 'pointer' }} onClick={() => setOpenTarget({ open: title })}>
            {i18n.language.startsWith('ko')
              ? `${title} ${t('Settings.label.change')}`
              : `${t('Settings.label.change')} ${title.toLocaleLowerCase()}`}
          </Typography>
          <Dialog onClose={() => setOpenTarget({ open: '' })} open={openTarget.open === title}>
            {children}
          </Dialog>
        </>
      )}
    </Stack>
  );
}
